import { render, staticRenderFns } from "./fts-table.vue?vue&type=template&id=31ce23ea&scoped=true&"
import script from "./fts-table.vue?vue&type=script&lang=js&"
export * from "./fts-table.vue?vue&type=script&lang=js&"
import style0 from "./fts-table.vue?vue&type=style&index=0&id=31ce23ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ce23ea",
  null
  
)

export default component.exports